/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:20
 * @LastEditTime: 2021-06-21 14:52:37
 * @LastEditors: cc
 */
'use strict';
angular.module('productManageMentWeiboServiceModule', ['weiboAccountAddModule', 'weiboAccountBindModule', 'productManageMentEditWeiboModule', 'productManageMentSortWeiboModule'])
    .factory('productManageMentWeiboService', ['$q', '$modal', 'trsHttpService', 'globleParamsSet', function($q, $modal, trsHttpService, globleParamsSet) {
        return {

            /**
             * [getRight description] 获取微博操作权限
             * @param   {[type]}  AccountId  [AccountId description]
             * @param   {[type]}  classify   [classify description]
             * @return  {[type]}             [return description]
             */
            getRight: function(AccountId, classify) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyOfWeiBo',
                    AccountId: AccountId,
                    Classify: classify
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                    .then(function(data) {
                        var right = {};
                        for (var i = 0; i < data.length; i++) {
                            right[data[i].OPERNAME.split('.')[2]] = true;
                        }
                        deffer.resolve(right);
                    });
                return deffer.promise;
            },

            /**
             * [AccountAdd description] 添加微博账号
             * @param   {[Function]}  success  [success description] 成功后回调
             * @return  {[type]}               [return description]
             */
            AccountAdd: function(success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/weibo/service/weiboAccountAdd/weiboAccountAdd_tpl.html',
                    windowClass: 'weibo-account-add',
                    backdrop: false,
                    controller: 'weiboAccountAddCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [AccountBind description] 微博视频发布账号认证
             * @param {[type]} success [description]
             */
            /**
             * [AccountBind description] 微博视频发布账号认证
             * @param   {[type]}  success  [success description]
             * @param   {[type]}  options  [options description]
             * @return  {[type]}           [return description]
             */
            AccountBind: function(success, options) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/weibo/service/weiboAccountBind/weiboAccountBind_tpl.html',
                    windowClass: 'weibo-account-add',
                    backdrop: false,
                    controller: 'weiboAccountBindCtrl',
                    resolve: {
                        options: function(){
                            return options;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [edit description] 修改微博配置
             * @param   {[type]}  item     [item description]
             * @param   {[type]}  right    [right description]
             * @param   {[type]}  success  [success description]
             * @return  {[type]}           [return description]
             */
            edit: function(item, right, success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/weibo/service/editWeibo/editWeibo_tpl.html',
                    windowClass: 'productManageMent-weibo-edit',
                    backdrop: false,
                    resolve: {
                        item: function() {
                            return item;
                        },
                        itemRight: function() {
                            return right;
                        }
                    },
                    controller: 'productManageMentEditWeiboCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [sort description] 微博账号排序
             * @param  {[object]} item    [description] 微博账号
             * @param  {[Function]} success [description] 成功后的回调函数
             * @return {[type]}         [description]
             */
            sort: function(item, success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/weibo/service/sortWeibo/sortWeibo_tpl.html',
                    windowClass: 'productManageMent-weibo-sort',
                    backdrop: false,
                    resolve: {
                        item: function() {
                            return item;
                        }
                    },
                    controller: 'productManageMentSortWeiboCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }
        };
    }]);
